import cc from 'store/util/createReduxConstant';
import { createRequestConstantNames } from 'store/util/createConstants';

export const [
  CANCEL_WAIVE_REQUEST,
  CANCEL_WAIVE_REQUEST_SUCCESS,
  CANCEL_WAIVE_REQUEST_FAIL,
] = createRequestConstantNames(cc('CANCEL_WAIVE_REQUEST'));
